const getEnvVar = (key) => {
  // In production, read from window._env_ (injected at runtime)
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }

  // In development, try both VITE_ and REACT_APP_ prefixes
  const viteKey = key.replace("REACT_APP_", "VITE_");
  return import.meta.env[viteKey] || import.meta.env[key] || process.env[key];
};

export const env = {
  REACT_APP_BACKEND_URL: getEnvVar("REACT_APP_BACKEND_URL"),
  REACT_APP_SITE_KEY: getEnvVar("REACT_APP_SITE_KEY"),
  REACT_APP_DOMAIN: getEnvVar("REACT_APP_DOMAIN"),
  REACT_APP_CLIENTID: getEnvVar("REACT_APP_CLIENTID"),
  REACT_APP_AUDIENCE: getEnvVar("REACT_APP_AUDIENCE"),
  REACT_APP_REDIRECTURI: getEnvVar("REACT_APP_REDIRECTURI"),
};

export default env;
